// src/api/apiClient.js
import { EnvironmentConfig } from "../config/environmentConfig";
import { getAccessToken } from "../contexts/auth/tokenProvider";

const API_BASE_URL = EnvironmentConfig.api.baseUrl;
const OCCTOO_BASE_URL = EnvironmentConfig.occtoo.baseUrl;
const AM_JOB_BASE_URL = EnvironmentConfig.amJob.baseUrl;
const AM_JOB_API_KEY = EnvironmentConfig.amJob.key;

export async function apiRequest(endpoint, options = {}) {
  const token = await getAccessToken();
  const isFormData = options.body instanceof FormData;

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    //const error = await response.text();
    console.error(response);
    return response;
  }

  return response.json();
}

export async function occtooApiRequest(endpoint, options = {}) {
  const isFormData = options.body instanceof FormData;

  const response = await fetch(`${OCCTOO_BASE_URL}${endpoint}`, {
    ...options,
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || "API request failed");
  }

  try {
    const data = await response.json();
    return data;
  } catch (e) {
    throw e;
  }
}

export function postIncludedFeatureJob(userId, featureId) {
  var oldUrl = `http://localhost:7075/api/IncludedFeatureJobQueue`;
  return fetch(
    `${AM_JOB_BASE_URL}IncludedFeatureJobQueue?code=${AM_JOB_API_KEY}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userId, featureId }),
    },
  ).then((r) => r.json());
}

export function getIncludedFeatureJob(featureId, jobId) {
  var oldUrl = `http://localhost:7075/api/IncludedFeatureJobQueue/${featureId}/${jobId}`;
  return fetch(
    `${AM_JOB_BASE_URL}IncludedFeatureJobQueue/${featureId}/${jobId}?code=${AM_JOB_API_KEY}`,
  );
}

export function getActiveIncludedFeatureJob(featureId) {
  var oldUrl = `http://localhost:7075/api/IncludedFeatureJobQueue/active/${featureId}?code=${AM_JOB_API_KEY}`;
  return fetch(
    `${AM_JOB_BASE_URL}IncludedFeatureJobQueue/active/${featureId}?code=${AM_JOB_API_KEY}`,
  );
}
